import $ from 'jquery'
import {Core} from "./core.js";

export class BannerTop {
  constructor() {
    this.$body = $('body')

    if (this.$body.hasClass('show-banner-top')) {
      this.$window = $(window)
      this.$header = $('header.header')
      this.$banner = $('.banner-top')

      this.offsetHeader = 0
      this.offsetBody = 75.2

      if (Core.isAdminFront()) {
        this.offsetHeader = 32
      }

      this.$window.on('resize', this.handleResize.bind(this))
      this.$window.on('scroll', this.handleScroll.bind(this))

      this.handleResize()
    }
  }

  handleScroll() {
    if (this.$window.scrollTop() > 0) {
      let currentScroll = this.$window.scrollTop();
      let heightBanner = this.$banner.outerHeight(true)

      if (currentScroll < heightBanner) {
        let calculatedTopHeader = heightBanner - currentScroll

        // this.$header.css('top', calculatedTopHeader + 'px')
      } else {
        this.$header.removeAttr('style')
      }
    } else {
      this.handleResize()
    }
  }

  handleResize() {
    const heightBanner = this.$banner.outerHeight(true)

    const offsetBody = this.offsetBody + heightBanner
    const offsetHeader = this.offsetHeader + heightBanner

    this.$body.css('padding', offsetBody + 'px 0 0')
    // this.$header.css('top', offsetHeader + 'px')
    this.$body[0].style = '--banner-height: ' + heightBanner + 'px';
  }
}
